import { TFunction } from "i18next";
import * as yup from "yup";

export const schema = (t: TFunction, isGuest?: boolean) => {
  return yup
    .object({
      username: isGuest ? yup.string().required() : yup.string().notRequired(),
      phoneNumber: isGuest
        ? yup.string().required()
        : yup.string().notRequired(),
      email: isGuest
        ? yup
            .string()
            .email(t("contactUs.input.validation.email.text"))
            .required()
        : yup.string().notRequired(),
      comments: yup.string(),
    })
    .required();
};
